import { TFunction } from "i18next";
import * as yup from "yup";

export const MIN_AMOUNT_ADD_FUNDS = 0.01;
export const MAX_AMOUNT_ADD_FUNDS = 10000;

export const sanitizeAddFundsAmountInput = (value: string): string =>
  value.replace(/[^0-9.]/g, "");

export const createAddFundsAmountValidation = (
  t: TFunction,
  currencySymbol = "$",
) =>
  yup
    .string()
    .required(t("error.requiredField"))
    .test(
      "amount-range",
      t("books.errorAmountRangeAddFunds", {
        min: MIN_AMOUNT_ADD_FUNDS,
        max: MAX_AMOUNT_ADD_FUNDS,
        currencySymbol,
      }),
      (value) => {
        const amount = Number(value);
        return (
          Number.isFinite(amount) &&
          amount >= MIN_AMOUNT_ADD_FUNDS &&
          amount <= MAX_AMOUNT_ADD_FUNDS
        );
      },
    );
